<template>
  <div class="page-client-detail">
    <clienti-detail />
  </div>
</template>

<script>
import ClientiDetail from '@/components/ask/details/ClientiDetail.vue'

export default {
  name: 'ViewClientiDetail',
  components: {
    ClientiDetail,
  },

  data() {
    return {
      pageName: 'ClientiDetail',
    }
  },

  created(){

  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },
  
}
</script>
